var React = require('react');

function Swift (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M21.5084 5C25.2227 9.23606 24.4317 14.8841 23.5719 17.1787C23.4295 17.6023 22.8247 17.3552 22.5401 17.1787L10.6747 7.64754L16.8654 16.1196L7.06354 8.70655L19.4448 22.4737C14.0796 25.0154 7.57943 22.4737 5 20.8852C6.71962 22.8267 10.9843 27.0275 14.286 28.2983C17.5876 29.5691 21.1644 28.8278 22.5401 28.2983C23.228 27.7688 25.1196 26.6039 27.1831 26.1803C29.2466 25.7567 30.4504 27.7688 30.7943 28.8278C31.6197 25.0154 29.7625 22.2972 28.7308 21.4147C30.3816 12.519 24.6037 6.76502 21.5084 5Z","fill":"#5B59FB"}));
}

Swift.defaultProps = {"width":"36","height":"36","viewBox":"0 0 36 36","fill":"none"};

module.exports = Swift;

Swift.default = Swift;
